// WebKit may not have consumed an object URL when a synthetic anchor click
// returns. Revoking it synchronously can navigate Safari to a
// `WebKitBlobResource error 1` page, especially for larger generated files.
export const OBJECT_URL_DOWNLOAD_GRACE_PERIOD_MS = 60_000;

export const downloadBlob = (blob: Blob, fileName: string): void => {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.setTimeout(() => {
    URL.revokeObjectURL(objectUrl);
  }, OBJECT_URL_DOWNLOAD_GRACE_PERIOD_MS);
};
